import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { KolamDivider } from './KolamPattern';

const categories = [
  {
    id: 'mugs',
    name: 'Ceramic Mugs',
    description: 'Hand drawn kolam designs with positive quotes',
    image: '/products/mugs.jpg',
  },
  {
    id: 'coasters',
    name: 'Coasters',
    description: 'Beautiful kolam design MDF coasters',
    image: '/products/coasters-magnets.jpg',
  },
  {
    id: 'notebooks',
    name: 'Notebooks',
    description: 'Spiral & hardbound with kolam covers',
    image: '/products/notebooks-frames.jpg',
  },
  {
    id: 'frames',
    name: 'Wall Frames',
    description: 'Hand drawn kolams for wall or desk decor',
    image: '/products/notebooks-frames.jpg',
  },
  {
    id: 'calendars',
    name: 'Desk Calendars',
    description: '12 unique hand-drawn designs per calendar',
    image: '/products/calendars.jpg',
  },
  {
    id: 'gift-hampers',
    name: 'Gift Hampers',
    description: 'Customised hampers for any occasion',
    image: '/products/notebooks-frames.jpg',
  },
];

export function CategoryShowcase() {
  return (
    <section className="bg-warm-900 py-20 relative overflow-hidden">
      {/* Kolam-inspired dot pattern background */}
      <div className="absolute inset-0 opacity-5" style={{
        backgroundImage: `radial-gradient(circle at 2px 2px, white 1px, transparent 1px)`,
        backgroundSize: '30px 30px',
      }} />

      <div className="container-page relative">
        <div className="text-center mb-16">
          <motion.p
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            className="text-xs font-medium tracking-[0.3em] uppercase text-ochre mb-4"
          >
            Gallery Rooms
          </motion.p>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-4xl sm:text-5xl font-serif text-white mb-6"
          >
            Explore Collections
          </motion.h2>
          <motion.div
            initial={{ opacity: 0, scaleX: 0 }}
            whileInView={{ opacity: 1, scaleX: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
          >
            <KolamDivider className="w-64 h-8 mx-auto text-warm-600" />
          </motion.div>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {categories.map((category, index) => (
            <motion.div
              key={category.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
            >
              <a
                href={`/products?category=${category.id}`}
                className="block group"
              >
                {/* Gallery room card */}
                <div className="bg-warm-800/50 backdrop-blur-sm border border-warm-700/50 rounded-lg overflow-hidden hover:border-ochre/50 transition-all duration-300">
                  <div className="relative aspect-[4/3] overflow-hidden">
                    <img
                      src={category.image}
                      alt={category.name}
                      className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-warm-900/60 to-transparent" />
                  </div>
                  <div className="p-6">
                    <div className="flex items-center justify-between mb-2">
                      <h3 className="text-xl font-serif text-white">{category.name}</h3>
                      <ArrowRight className="w-5 h-5 text-ochre opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300" />
                    </div>
                    <p className="text-warm-400 text-sm">{category.description}</p>
                  </div>
                </div>
              </a>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
